import {
  DISCOUNTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  DISCOUNTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  DISCOUNTS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  DISCOUNTS_MASSIVE_UPLOAD_SET_VERIFY,
  DISCOUNTS_MASSIVE_UPLOAD_CLEAR_VERIFY,
  DISCOUNTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  DISCOUNTS_MASSIVE_UPLOAD_SET_UPLOAD,
  DISCOUNTS_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function discountsMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case DISCOUNTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case DISCOUNTS_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default discountsMassiveUploadReducer;
